import { MAILTO_SUPPORT_HREF, SUPPORT_EMAIL } from '../constants/publicSite';

/** Opens the default mail client to contact product support (`REACT_APP_SUPPORT_EMAIL` / `SUPPORT_EMAIL`). */
export function openAppHelp() {
  window.location.href = MAILTO_SUPPORT_HREF;
}

/** Tooltip / aria description for help actions */
export function appHelpDescription() {
  return `Contact support — ${SUPPORT_EMAIL}`;
}
